import { render, staticRenderFns } from "./PhotoPreview.vue?vue&type=template&id=38b779f6&"
import script from "./PhotoPreview.vue?vue&type=script&lang=js&"
export * from "./PhotoPreview.vue?vue&type=script&lang=js&"
import style0 from "./PhotoPreview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports